module.exports = __webpack_public_path__ + "static/media/flash_card_verso.7b9674c3.svg";